var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsapp-container"},[_c('span',{staticClass:"whatsapp-text"},[_vm._v(" Fale conosco ")]),_c('a',{staticClass:"btn-whatsapp",attrs:{"href":_vm.linkWhats,"target":"_blank","title":"Fale conosco no WhatsApp"}},[_c('i',{staticClass:"fab fa-whatsapp"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }